import { generateUtilityClass, generateUtilityClasses } from '@mui/base';
export function getTabsUtilityClass(slot) {
  return generateUtilityClass('MuiTabs', slot);
}
const tabsClasses = generateUtilityClasses('MuiTabs', ['root', 'vertical', 'flexContainer', 'flexContainerVertical', 'centered', 'scroller', 'fixed', 'scrollableX', 'scrollableY', 'hideScrollbar', 'scrollButtons', 'scrollButtonsHideMobile', 'indicator']);
export default tabsClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/Tabs/tabsClasses.js
// module id = 388
// module chunks = 1